import { formatRatePercent, statusLabel } from '@saay/formatting';
import type { Tone } from '@saay/blocks';

/**
 * Persian labels for §28 enums that are not in the central status dictionary yet.
 * A value the map does not know is «نامشخص», the same neutral label as an unknown enum.
 */

const LABELS: Readonly<Record<string, string>> = {
  ACTIVE: 'فعال',
  BUYER_ORGANIZATION: 'سازمان',
  CANCELLED: 'لغوشده',
  DRAFT: 'پیش‌نویس',
  ENDED: 'پایان‌یافته',
  FAILED: 'ناموفق',
  HELD: 'متوقف',
  INACTIVE: 'غیرفعال',
  LOCKED: 'در حال پرداخت',
  MANUAL: 'دستی',
  MERCHANT: 'فروشگاه',
  PAID: 'پرداخت‌شده',
  PAYOUT_ACCOUNT_CHANGE: 'تغییر حساب',
  PENDING: 'در انتظار',
  PROCESSING: 'در حال انجام',
  PUBLISHED: 'منتشرشده',
  PURCHASE_AMOUNT: 'مبلغ خرید',
  RELEASED: 'آزادشده',
  RETIRED: 'بازنشسته',
  REVERSED: 'برگشت‌خورده',
  SAAY_FEE: 'کارمزد SAAY',
  SCHEDULED: 'زمان‌بندی‌شده',
  SUCCEEDED: 'موفق',
};

const TONES: Readonly<Record<string, Tone>> = {
  ACTIVE: 'olive',
  CANCELLED: 'forest',
  DRAFT: 'clay',
  ENDED: 'forest',
  FAILED: 'danger',
  HELD: 'copper',
  INACTIVE: 'forest',
  LOCKED: 'clay',
  PAID: 'olive',
  PENDING: 'clay',
  PROCESSING: 'clay',
  PUBLISHED: 'olive',
  RELEASED: 'forest',
  RETIRED: 'forest',
  REVERSED: 'copper',
  SCHEDULED: 'gold',
  SUCCEEDED: 'olive',
};

export function marketingLabel(value: string): string {
  return LABELS[value] ?? 'نامشخص';
}

export function marketingTone(value: string): Tone {
  return TONES[value] ?? 'forest';
}

/** Recipient status is the shared active/inactive dictionary. */
export function recipientStatusLabel(value: string): string {
  return statusLabel('activeStatus', value);
}

/** A rate string, including a leading minus on a margin, without recomputing it. */
export function formatSignedRate(rate: string): string {
  if (rate.startsWith('-')) {
    return `−${formatRatePercent(rate.slice(1), { invalid: 'raw' })}`;
  }
  return formatRatePercent(rate, { invalid: 'raw' });
}
